import { Keys } from '../../layout/core/utilities/localization/gcis-payment';
import { useShowErrorWithCallback } from './use-show-error-with-callback.hook';

export function useShowPaymentErrorWithCallback() {
    const showError = useShowErrorWithCallback();
    return (key: Keys, description?: string) =>
        (callback = () => {}) =>
            showError(['GcisPayment', key], description)(callback);
}
